<div class="order-wizard-container">
  <!-- Countdown Timer (shown when orders are disabled) -->
  @if (ordersDisabled()) {
    <app-countdown-timer
      [targetDate]="orderStartDate"
      message="orders_start_at"
    />
  }

  <!-- Main Wizard Content -->
  <div class="wizard-content" [class.disabled-content]="ordersDisabled()">
    <!-- Progress Steps -->
    <div class="wizard-progress">
      <div class="progress-steps">
        <!-- Step 1: Product Selection -->
        <div
          class="progress-step"
          [class.active]="currentStep() === 1"
          [class.completed]="currentStep() > 1"
        >
          <div class="step-circle">
            @if (currentStep() < 2) { <span class="step-number">1</span> }
            @else { <svg cIcon name="cilCheckAlt"></svg> }
          </div>
          <span class="step-label">{{ 'wizard_step_select_products' | translate }}</span>
        </div>

        <div class="progress-line" [class.completed]="currentStep() > 1"></div>

        <!-- Step 2: Payment Method -->
        <div
          class="progress-step"
          [class.active]="currentStep() === 2"
          [class.completed]="currentStep() > 2"
        >
          <div class="step-circle">
            @if (currentStep() < 3) { <span class="step-number">2</span> }
            @else { <svg cIcon name="cilCheckAlt"></svg> }
          </div>
          <span class="step-label">{{ 'wizard_step_payment_method' | translate }}</span>
        </div>

        <div class="progress-line" [class.completed]="currentStep() > 2"></div>

        <!-- Step 3: Payment Confirmation -->
        <div
          class="progress-step"
          [class.active]="currentStep() === 3"
          [class.completed]="currentStep() > 3"
        >
          <div class="step-circle">
            @if (currentStep() < 4) { <span class="step-number">3</span> }
            @else { <svg cIcon name="cilCheckAlt"></svg> }
          </div>
          <span class="step-label">{{ 'wizard_step_confirm_payment' | translate }}</span>
        </div>

        <div class="progress-line" [class.completed]="currentStep() > 3"></div>

        <!-- Step 4: Success -->
        <div
          class="progress-step"
          [class.active]="currentStep() === 4"
        >
          <div class="step-circle">
            <span class="step-number">4</span>
          </div>
          <span class="step-label">{{ 'wizard_step_success' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Step Content -->
    @switch (currentStep()) {
      @case (1) {
        <app-product-selection (onNext)="handleProductSelection()" />
      }
      @case (2) {
        <app-payment-method
          [totalPrice]="totalPrice()"
          (onNext)="handlePaymentMethodSelection()"
          (onBack)="handleBack(1)"
        />
      }
      @case (3) {
        @switch (paymentMethod()) {
          @case ('ewallet') {
            <app-ewallet-confirmation
              [orderId]="orderId()"
              [totalPrice]="totalPrice()"
              [currency]="currency()"
              (onSuccess)="handlePaymentSuccess($event)"
              (onBack)="handleBack(2)"
            />
          }
          @case ('credit_card') {
            <app-stripe-confirmation
              [orderId]="orderId()"
              [totalPrice]="totalPrice()"
              [paymentCosts]="paymentCosts()"
              [totalWithCosts]="totalWithCosts()"
              [currency]="currency()"
              (onSuccess)="handlePaymentSuccess($event)"
              (onBack)="handleBack(2)"
            />
          }
          @case ('authorize_net') {
            <app-authorize-net-confirmation
              [orderId]="orderId()"
              [totalPrice]="totalPrice()"
              [paymentCosts]="paymentCosts()"
              [totalWithCosts]="totalWithCosts()"
              [currency]="currency()"
              (onSuccess)="handlePaymentSuccess($event)"
              (onBack)="handleBack(2)"
            />
          }
          @case ('web3_payment') {
            <app-web3-confirmation
              [orderId]="orderId()"
              [totalPrice]="totalPrice()"
              [recipientAddress]="recipientAddress()"
              (onSuccess)="handlePaymentSuccess($event)"
              (onBack)="handleBack(2)"
            />
          }
        }
      }
      @case (4) {
        <app-order-success
          [orderId]="orderId()"
          [isFirstOrder]="isFirstOrder()"
        />
      }
    }
  </div>
</div>